import { reduxActions } from '../constants';

export default class UserManagementActions {
    static setTabState(state) {
        return {
            type: reduxActions.USER_MANAGEMENT_SET_TAB_STATE,
            state: state
        }
    }
}



// WEBPACK FOOTER //
// ./web-app/actions/user-management-actions.js